// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j19trwjcJt61GLqqs8As {
  background-color: #f6f8fa !important;
}
.AZoZmXyKIT4auo4IDE4G {
  display: inline-block;
  width: 8px;
  height: 8px;
  position: absolute;
  margin: 0px 0 0 -15px;
  background-color: red;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Notification/index.module.less"],"names":[],"mappings":"AAEA;EACE,oCAAA;AADF;AAIA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;AAFF","sourcesContent":["\n\n.readItem {\n  background-color: #f6f8fa !important;\n}\n\n.unreadIndicator {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  margin: 0px 0 0 -15px;\n  background-color: red;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"readItem": `j19trwjcJt61GLqqs8As`,
	"unreadIndicator": `AZoZmXyKIT4auo4IDE4G`
};
export default ___CSS_LOADER_EXPORT___;
